import { CULTIV_LOCALES } from '../site';
import { JOBS } from './jobs';
import type { Job, JobLocale, JobTranslation } from './types';

/** Language the postings are authored in — the fallback when a translation is missing. */
export const JOB_SOURCE_LOCALE: JobLocale = 'en';

export function findJob(slug: string, jobs: Job[] = JOBS): Job | undefined {
  return jobs.find((j) => j.slug === slug);
}

/** Locales this posting is actually readable in, in CULTIV_LOCALES order. */
export function translatedLocales(job: Job): JobLocale[] {
  return CULTIV_LOCALES.filter((l) => Boolean(job.i18n[l]));
}

/** The requested translation, falling back to the source locale and then to any
 *  available one, so a direct URL in an untranslated locale still renders. */
export function getJobTranslation(job: Job, locale: string): JobTranslation {
  const exact = job.i18n[locale as JobLocale];
  if (exact) return exact;
  const source = job.i18n[JOB_SOURCE_LOCALE];
  if (source) return source;
  const any = translatedLocales(job)[0];
  return job.i18n[any] as JobTranslation;
}

/** Openings readable in this locale, newest first. */
export function jobsForLocale(locale: string, jobs: Job[] = JOBS): Job[] {
  return jobs
    .filter((j) => Boolean(j.i18n[locale as JobLocale]))
    .sort((a, b) => b.postedAt.localeCompare(a.postedAt));
}
